import React from "react";
import * as appConst from "@app/state/constants";
const ReverseRouteCtx = React.createContext({} as any);

export const ReverseRoute = ({ children }: { children: any }) => {
  const loadedRoutes = React.useRef([]);
  return (
    <ReverseRouteCtx.Provider value={loadedRoutes.current}>
      {children}
    </ReverseRouteCtx.Provider>
  );
};

type TAppRoutes =
  | "AppHeader"
  | "NotFusionAuth"
  | "VerificationRequired"
  | "AuthRoutes"
  | typeof appConst.DRAWER_PAGES.DOWNLOAD
  | typeof appConst.DRAWER_PAGES.PROFILE
  | typeof appConst.DRAWER_PAGES.SWSADMIN_GROUPS
  | typeof appConst.DRAWER_PAGES.SWSADMIN_USERS
  | typeof appConst.PROFILE_PAGES.WHOAMI
  | typeof appConst.PROFILE_PAGES.DISTRIBUTION
  | "form/userdef";

/* 
 The motivation would be to have a list of all loaded sections / components
 not just routes.
 
 Each component would have a unique name, and would be added to the list
 when it is mounted, and removed when it is unmounted.

 it would be useful not to calculate each time if a condition is met to show or hide a related component.

 the initial aim was to show/hide menuitems based on loaded routes, but neah...s

 we could create a breacrumb component.
 we can show help menus based on the current route.

*/
export const useReverseRoute = (thisRoute: TAppRoutes) => {
  const routes = React.useContext(ReverseRouteCtx);
  const markerRef = React.useRef<HTMLDivElement>();
  const routeInit = (elem: HTMLDivElement) => {
    const foundRoute = routes.find((r: string) => r === thisRoute);
    if (elem) {
      if (foundRoute) {
        return;
      } else {
        markerRef.current = elem;
        routes.push(thisRoute);
      }
    } else {
      if (foundRoute) {
        markerRef.current = undefined;
        routes.splice(routes.indexOf(foundRoute), 1);
      } else {
        return;
      }
    }
    // console.log('LA FINAL routes', routes)
  };
  return {
    routes,
    routeInit,
  };
};
